export const useLegacyToastInterceptor = (appInstance) => {
    const toastmessage = (type, message) => {
        const toast = appInstance.config.globalProperties.$toast;
        let severity;
        switch (type) {
            case 'success':
                severity = 'success';
                break;
            case 'notice':
                severity = 'info';
                break;
            case 'warning':
                severity = 'warn';
                break;
            case 'error':
                severity = 'error';
                break;
            default:
                severity = 'info';
        }
        toast.add({ severity: severity, detail: message, life: 3000 });
    };
    function jqueryFake() {
        return { toastmessage: toastmessage };
    }
    jqueryFake.toastmessage = toastmessage;
    if (!window.$) {
        window.$ = jqueryFake;
        window.jQuery = jqueryFake;
    }
    const interceptInRealJquery = (jqueryInstance) => {
        jqueryInstance.toastmessage = toastmessage;
    };
    return { interceptInRealJquery };
};
